import React from 'react';
import { BAND_TRANSITION_MAPPING, AGE_BANDS } from '../../../utils/childChapterUtils';

/**
 * Shows old-to-new chapter name mapping in a small table.
 *
 * Props:
 *   fromBand - previous band key
 *   toBand   - new band key
 */
function BandTransitionMapping({ fromBand, toBand }) {
  const mappingKey = `${fromBand}_to_${toBand}`;
  const mapping = BAND_TRANSITION_MAPPING[mappingKey];

  if (!mapping) return null;

  const fromLabel = AGE_BANDS[fromBand]?.label || fromBand;
  const toLabel = AGE_BANDS[toBand]?.label || toBand;

  return (
    <div className="mt-3">
      <p className="text-sm font-medium text-[#556B2F] mb-2">
        Chapter mapping: {fromLabel} &rarr; {toLabel}
      </p>
      <div className="overflow-hidden rounded-lg border border-[#556B2F]/20">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#556B2F]/10">
              <th className="text-left px-3 py-2 font-medium text-[#556B2F]">Previous</th>
              <th className="text-center px-2 py-2 text-[#556B2F]/60">&rarr;</th>
              <th className="text-left px-3 py-2 font-medium text-[#556B2F]">New</th>
            </tr>
          </thead>
          <tbody>
            {mapping.map((row, idx) => (
              <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-[#F5F5DC]/50'}>
                <td className="px-3 py-2 text-gray-700">{row.from}</td>
                <td className="text-center px-2 py-2 text-gray-400">&rarr;</td>
                <td className="px-3 py-2 text-gray-700 font-medium">{row.to}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default BandTransitionMapping;
